import { render } from "./z-pagination.vue?vue&type=template&id=9851c82a&ts=true"
import script from "./z-pagination.vue?vue&type=script&lang=ts"
export * from "./z-pagination.vue?vue&type=script&lang=ts"

import "./z-pagination.vue?vue&type=style&index=0&id=9851c82a&lang=scss&scope=true"

import exportComponent from "/home/runner/work/hub_thunnus/hub_thunnus/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/base/z-pagination.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "9851c82a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('9851c82a', __exports__)) {
    console.log('reload')
    api.reload('9851c82a', __exports__)
  }
  
  module.hot.accept("./z-pagination.vue?vue&type=template&id=9851c82a&ts=true", () => {
    console.log('re-render')
    api.rerender('9851c82a', render)
  })

}


export default __exports__